export enum FraudOptions {
  CONFIG_NAME = 'Fraud',
  SURVEY_ORIGIN_UNKOWN = 'unknown',
}
